export default "__VITE_ASSET__8c427f02__"